import { Facebook, Instagram, YouTube } from '@material-ui/icons'
import React from 'react'
import './Footer.css'
import LogoD from './images/LogoD.jpg'

function Footer() {
    return (
        <div className='footer'>
            <div className="footer__logo">
                <img src={LogoD} />
            </div>

            <div className="footer__flex">
                <p>About</p>
                <p>News</p>
                <p>Projects</p>
                <p>Privacy policy</p>
            </div>
            
            <div className='footer__form'>
                <p>Be the first to get our latest news</p>
                <form>
                    <input placeholder='sahtitus58@gmail.com' />
                    <button type='submit'>Subscribe</button>
                </form>
            </div>
            

            <div className="footer__followUs">
                <p>Stay connected!</p>
                <div className="footer__followUsOption">
                    <Facebook className="footer__followUsIcon" />
                    <Instagram className="footer__followUsIcon"/>
                    <YouTube className="footer__followUsIcon"/>
                </div>
            </div>

            <div className="footer__contactUs">
                <h4>Madamfo Ghana EV</h4>
                <p>Contact us</p>
                <span>Bettina Landgrafe</span>
                <span>Voerder Strasse 139A</span>
                <span>58135 Hagen, Germany</span>
                <span>Tel: +0049 (0) 2331 - 1278278</span>
                <span>Fax: +0049 (0) 163 - 7703867</span>
                <span>mail@madamfo-ghana.de</span>
            </div>

            <div className="footer__copyright">
                <p>©️ 2020-2021 Madamfo Ghana ev. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Footer
